import React from 'react';
import { MinusIcon, PlusIcon, TrashIcon, ArrowRightIcon } from 'lucide-react';
import { CartItem as CartItemType, Product } from '../types';
import { RDGuidanceBadge } from './RDGuidanceBadge';
interface CartItemProps {
  item: CartItemType;
  onUpdateQuantity: (productId: string, quantity: number) => void;
  onRemove: (productId: string) => void;
  onSwap?: (currentProductId: string, alternativeId: string) => void;
  allProducts?: Product[];
}
export function CartItem({
  item,
  onUpdateQuantity,
  onRemove,
  onSwap,
  allProducts
}: CartItemProps) {
  const {
    product,
    quantity
  } = item;
  const itemTotal = product.price * quantity;
  const alternative = product.healthierAlternative && allProducts ? allProducts.find(p => p.id === product.healthierAlternative) : null;
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-4" data-id="element-6">
      <div className="flex gap-3" data-id="element-7">
        <img src={product.image} alt={product.name} className="w-20 h-20 object-cover rounded-xl" data-id="element-8" />

        <div className="flex-1 min-w-0" data-id="element-9">
          <div className="flex items-start justify-between gap-2 mb-1" data-id="element-10">
            <div data-id="element-11">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-12">
                {product.name}
              </h3>
              <p className="text-xs text-gray-500" data-id="element-13">{product.size}</p>
            </div>
            <button onClick={() => onRemove(product.id)} className="text-gray-400 hover:text-red-500 transition-colors p-1" aria-label="Remove item" data-id="element-14">
              <TrashIcon className="w-4 h-4" data-id="element-15" />
            </button>
          </div>

          {product.rdRecommendation && product.rdRecommendation !== 'neutral' && <div className="mb-2" data-id="element-16">
                <RDGuidanceBadge recommendation={product.rdRecommendation} size="sm" data-id="element-17" />
              </div>}

          {product.rdNote && <div className={`rounded-lg p-2 mb-2 text-xs border ${product.rdRecommendation === 'recommended' ? 'bg-green-50 border-green-200 text-green-800' : product.rdRecommendation === 'limit' ? 'bg-amber-50 border-amber-200 text-amber-800' : 'bg-gray-50 border-gray-200 text-gray-700'}`} data-id="element-18">
              {product.rdNote}
            </div>}

          {alternative && onSwap && <button onClick={() => onSwap(product.id, alternative.id)} className="w-full bg-purple-100 hover:bg-purple-200 text-purple-700 font-medium py-1.5 px-3 rounded-full flex items-center justify-center gap-2 transition-colors mb-2 text-xs" data-id="element-19">
              <span data-id="element-20">Swap for {alternative.name}</span>
              <ArrowRightIcon className="w-3 h-3" data-id="element-21" />
            </button>}

          <div className="flex items-center justify-between" data-id="element-22">
            <div className="flex items-center gap-2 bg-gray-100 rounded-full p-1" data-id="element-23">
              <button onClick={() => onUpdateQuantity(product.id, Math.max(1, quantity - 1))} className="w-7 h-7 flex items-center justify-center rounded-full bg-white hover:bg-gray-50 transition-colors" aria-label="Decrease quantity" data-id="element-24">
                <MinusIcon className="w-4 h-4 text-gray-700" data-id="element-25" />
              </button>
              <span className="w-8 text-center font-medium text-sm" data-id="element-26">
                {quantity}
              </span>
              <button onClick={() => onUpdateQuantity(product.id, quantity + 1)} className="w-7 h-7 flex items-center justify-center rounded-full bg-white hover:bg-gray-50 transition-colors" aria-label="Increase quantity" data-id="element-27">
                <PlusIcon className="w-4 h-4 text-gray-700" data-id="element-28" />
              </button>
            </div>

            <div className="text-right" data-id="element-29">
              <p className="font-bold text-gray-900" data-id="element-30">${itemTotal.toFixed(2)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}